import BaseStatistics from './BaseStatistics';

export default BaseStatistics;
